<template>
    <main>
        <div class="container-fluid">
            <div class="row d-flex justify-content-between flex-wrap align-items-center">
                <div class="container-fluid">
                    <div class="row d-flex justify-content-between flex-wrap align-items-center">
                        <div class="col-sm-6">
                            <a
                                href="#"
                                @click.prevent="onShowOrdersList"
                            >
                                <font-awesome-icon :icon="['fas', 'chevron-left']" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8">
                    <h2 class="mb-0">{{$t('Ordine')}} #{{order.num}}</h2>
                    <p class="mb-0 mt-1">{{order.creationDate}}</p>
                </div>
                <div class="col-sm-4 mt-3 mt-sm-0">
                    <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                        <li class="w-100 d-sm-flex justify-content-end mb-0">
                            <p class="mb-0"><span class="d-inline-block">(<a href="#">{{order.eventTitle}}</a>)</span></p>
                        </li>
                        <li class="w-100 d-sm-flex justify-content-end mb-0 mt-1">
                            <p class="mb-0">
                                <span
                                    v-if="order.status === '0'"
                                    class="status"
                                >{{$t('Da elaborare')}}</span>
                                <span
                                    v-if="['2', '3', '4', '5'].includes(order.status)"
                                    class="status txt-success"
                                >{{$t('In stampa')}}</span>
                                <span
                                    v-if="order.status === '6'"
                                    class="status"
                                >{{$t('Spedito')}}</span>
                                <span
                                    v-if="order.status === '7'"
                                    class="status"
                                >{{$t('Consegnato')}}</span>
                                <span
                                    v-if="order.status === '8'"
                                    class="status"
                                >{{$t('Annullato')}}</span>
                                <span
                                    v-if="['V', 'P'].includes(order.status)"
                                    class="status"
                                >{{$t('Da pagare')}}</span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <table class="tabella-ordine tabella-responsive table table-striped mt-3 mb-0">
                <thead>
                    <tr>
                        <th
                            scope="col"
                            class="px-1"
                        ><a href="#">{{$t('Articolo')}} <i class="fas fa-caret-down"></i>
                                <!--<i class="fas fa-caret-up"></i>-->
                            </a></th>
                        <th
                            scope="col"
                            class="px-1"
                        ><a href="#">{{$t('Qty')}}</a></th>
                        <th
                            scope="col"
                            class="px-1"
                        ><a href="#">{{$t('Stato')}}</a></th>
                        <th
                            scope="col"
                            class="px-1"
                        ><a href="#">{{$t('Importo')}}</a></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        class="riga mt-0"
                        v-for="detail in order.details"
                        v-bind:key="detail.articleCode"
                    >
                        <td
                            data-title="Articolo"
                            class="align-middle px-1"
                        >{{detail.articleName}}</td>
                        <td
                            data-title="Qty"
                            class="align-middle px-1"
                        >{{detail.quantity}}</td>
                        <td
                            v-if="detail.status === '0'"
                            data-title="Stato"
                            class="align-middle px-1"
                        >{{$t('Da elaborare')}}</td>
                        <td
                            v-if="['2', '3', '4', '5'].includes(detail.status)"
                            data-title="Stato"
                            class="align-middle px-1"
                        >{{$t('In stampa')}}</td>
                        <td
                            v-if="detail.status === '6'"
                            data-title="Stato"
                            class="align-middle px-1"
                        >{{$t('Spedito')}}</td>
                        <td
                            v-if="detail.status === '7'"
                            data-title="Stato"
                            class="align-middle px-1"
                        >{{$t('Consegnato')}}</td>
                        <td
                            v-if="detail.status === '8'"
                            data-title="Stato"
                            class="align-middle px-1"
                        >{{$t('Annullato')}}</td>
                        <td
                            v-if="['V', 'P'].includes(detail.status)"
                            class="align-middle px-1"
                        >{{$t('Da pagare')}}</td>
                        <td
                            data-title="Importo"
                            class="align-middle px-1"
                        >{{detail.quantity * detail.price}} €</td>
                    </tr>
                    <!-- <tr class="riga spedizione"> TODO
                    <td colspan="3" data-title="Articolo" class="align-middle px-1">{{$t('Spese di spedizione')}}</td>
                    <td data-title="Importo" class="align-middle px-1">3,90 €</td>
                </tr> -->
                </tbody>
            </table>
            <p class="totale mb-0 mt-3 text-right font-weight-bold h5">{{$t('Totale')}}: {{order.total}} €</p>
            <div class="row mt-5">
                <div class="col-sm-4">
                    <h2 class="mb-0 h4">{{$t('Tracking ordine')}}</h2>
                    <p class="mb-0 mt-1">{{$t('Stato ordine')}}:
                        <span
                            v-if="order.status === '0'"
                            class="status"
                        >{{$t('Da elaborare')}}</span>
                        <span
                            v-if="['2', '3', '4', '5'].includes(order.status)"
                            class="status txt-success"
                        >{{$t('In stampa')}}</span>
                        <span
                            v-if="order.status === '6'"
                            class="status"
                        >{{$t('Spedito')}}</span>
                        <span
                            v-if="order.status === '7'"
                            class="status"
                        >{{$t('Consegnato')}}</span>
                        <span
                            v-if="order.status === '8'"
                            class="status"
                        >{{$t('Annullato')}}</span>
                        <span
                            v-if="['V', 'P'].includes(order.status)"
                            class="status"
                        >{{$t('Da pagare')}}</span>
                    </p>
                </div>
                <div class="col-sm-4">
                    <h2 class="mb-0 h4">{{$t('Tipo pagamento')}}</h2>
                    <span>{{order.paymentType}}</span>
                </div>
                <div class="col-sm-4 mt-3 mt-sm-0">
                    <h2 class="mb-0 h4">{{$t('Consegna presso')}}</h2>
                    <p class="mb-0 mt-1">{{order.address}}, {{order.zip}}</p>
                    <p class="mb-0 mt-1">{{order.city}}, {{order.province}}</p>
                    <p class="mb-0 mt-1">{{order.country}}</p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "AccountDetail",
    props: {
        order: Object
    },
    methods: {
        onShowOrdersList() {
            this.$emit("showOrdersList");
        }
    }
};
</script>

<style scoped>
</style>
